<template lang="pug">
  section.brands
    h2 Marcas Asociadas
    a.brand(v-for="(brand, index) in brands" :href="brand.url")
      img(:src="brand.logo", :alt="brand.name")
</template>
<script>
export default {
  props: {
    brands: Array
  }
}
</script>
<style lang="scss" scoped>
  .brands{
    padding: 3rem 1rem;
    border-top: 5px solid $blue;
    border-bottom: 5px solid $blue;
    position: relative;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 1rem;
    overflow: hidden;
    @media (max-width: 800px){
      grid-template-columns: repeat(3, 1fr);
    }
    &:before,
    &:after{
      position: absolute;
      content: '';
      width: 100%;
      left: 0;
      border-bottom: 2px solid $blue;
    }
    &:before{
      top: 5px;
    }
    &:after{
      bottom: 5px;
    }

  }
  h2{
    text-transform: uppercase;
    text-align: center;
    grid-column: 1 / -1;
  }
  .brand{
    border: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    transition: all .2s ease-out;
    &:hover{
      transform: scale(1.1);
      border-color: black;
    }
  }

</style>

